module.exports = "/_next/static/images/d854865d22dcc321fbc98773a469a2f2-icon-monthly-payments.svg";